import { combineReducers } from "redux";
import alertReducer from "./alert";
import authReducer from "./auth";
import reportReducer from "./report";

export default combineReducers({
    alertReducer,
    authReducer,
    reportReducer
})